export default "__VITE_ASSET__BL_Yhb8D__"